import {faArrowDown, faArrowUp} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import * as styles from './metric-delta.scss';

type PropsType = {
    delta: number | null | undefined;
    // Shown instead of the arrow when the score did not move (or is unknown); nothing by default.
    emptyLabel?: string;
};

// Change of a score against the previous run, shared by the brand-analysis hero and the
// competitor ranking table.
export function MetricDelta(props: PropsType): JSX.Element | null {
    const {delta, emptyLabel} = props;

    if (typeof delta !== 'number' || delta === 0) {
        return emptyLabel ? <span>{emptyLabel}</span> : null;
    }

    const isPositive = delta > 0;
    const modifierClassName = isPositive ? styles.metric_delta__positive : styles.metric_delta__negative;

    return (
        <span className={`${styles.metric_delta} ${modifierClassName}`}>
            <FontAwesomeIcon className={styles.metric_delta__icon} icon={isPositive ? faArrowUp : faArrowDown} />
            {isPositive ? `+${delta}` : delta}
        </span>
    );
}
